import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { SComfortSelection } from '@slg/web-customer-shared';
import { useStore, useRouteRef } from '@/composables';


const __default__ = {
  name: 'ComfortSelection',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['clearBookingRequestError'],
  setup(__props, { emit }) {


const store = useStore();
const route = useRouteRef();

const getVehicleCategoryId = computed(() => store.getters['booking/getVehicleCategoryId']);
const getVehicleCategories = computed(() => store.getters['opsZone/getVehicleCategories']);
const comfortTypeItems = computed(() => {
  const availableVehicleTypes = getVehicleCategories.value.map((category: any) => (
    {
      text: category.localizedName[route.value.params.lang]
        || category.localizedName.en
        || category.identifier,
      value: category.vehicleCategoryId,
    }
  ));
  return availableVehicleTypes || [];
});

function setVehicleFeatures(vehicleFeatures: any[], maxSpecialSeatCapacity: number) {
  const selectedFeatures = vehicleFeatures.map((feature) => (
    {
      ...feature,
      amount: 0,
      showIcon: false,
    }
  ));
  if (maxSpecialSeatCapacity) {
    const localizedVehicleFeatureName = {
      en: 'Wheelchair Place',
      fr: 'Fauteuil roulant',
      es: 'Wheelchair Place -es',
      pt: 'Wheelchair Place -pt',
      nl: 'Wheelchair Place -nl',
      de: 'Rollstuhl',
      it: 'Wheelchair Place -it',
    };
    const wheelchairPlace = {
      vehicleFeatureId: 'wheelchairPlace',
      capacity: maxSpecialSeatCapacity,
      amount: 0,
      price: 0,
      localizedVehicleFeatureName,
      svgIconBase64: 'mdi-wheelchair-accessibility',
      showIcon: true,
    };
    selectedFeatures.push(wheelchairPlace);
  }
  store.commit('booking/setFeatures', selectedFeatures);
}

function setComfortType(newValue: string) {
  const {
    vehicleCategoryId,
    vehicleFeatures,
    maxSpecialSeatCapacity,
    localizedName,
  } = getVehicleCategories.value.find((category: any) => category.vehicleCategoryId === newValue);
  store.commit('booking/setVehicleCategoryId', vehicleCategoryId);
  store.commit('booking/setVehicleCategoryLocalizedName', localizedName);
  emit('clearBookingRequestError');
  setVehicleFeatures(vehicleFeatures, maxSpecialSeatCapacity);
}

return { __sfc: true,emit, store, route, getVehicleCategoryId, getVehicleCategories, comfortTypeItems, setVehicleFeatures, setComfortType, SComfortSelection }
}

})